import { resolve } from 'inversify-react';
import * as React from 'react';
import images from "src/assets/images";
import Button from 'src/core/ui/button';
import Grid from 'src/core/ui/grid';
import FormInput from 'src/core/ui/input';
import Modal from 'src/core/ui/modal';
import { actions as homeActions } from '../../../actions/home.actions';
import Form from '../../../core/ui/form';
import { Col } from '../../../core/ui/grid';
import ToastService from '../../../services/toast.service';
import IdentityService from "../../../services/identity.service";

export interface LoginFormProps {
}

export interface LoginFormState {
    loadingLogIn: boolean;
    loadingPassword: boolean;

    loginEmail: string;
    loginPassword: string;

    loginErrors?: string[];
    passwordErrors?: string[];
    generalErrors?: string[];

    forgotPassword: boolean;
    recoverEmail: string;
    forgotErrors?: string[];
}

export default class LoginForm extends React.Component<LoginFormProps &  typeof homeActions, LoginFormState> {
  constructor(props: any) {
    super(props);

    this.state = {
        loadingLogIn: false,
        loadingPassword: false,
        loginEmail: '',
        loginPassword: '',
        forgotPassword: false,
        recoverEmail: ''
    }
  }

  login = () => {
    this.setState({ loadingLogIn: true });
    this.identity.login(this.state.loginEmail, this.state.loginPassword).then(result=>{
      this.setState({loadingLogIn: false, loginEmail: '', loginPassword: '', loginErrors: [], passwordErrors: [], generalErrors: []});
    }).catch(error => {
      this.setState({loadingLogIn: false, loginErrors: error.email, passwordErrors: error.password, generalErrors: error.non_field_errors, forgotErrors: error.email});
      
    });
  }

  forgotPassword = () => {
    this.setState({ loadingPassword: true });
    this.identity.forgotPassword(this.state.recoverEmail).then(result => {
      this.setState({loadingPassword: false, forgotPassword: false, recoverEmail: '', forgotErrors: undefined});
    })
    .catch(error => {
      this.toasts.showToast("Password forgot", "Oops something went wrong", 'error');
      this.setState({loadingPassword: false, forgotErrors: error.email})
    })
  }

  @resolve(ToastService)
  public toasts: ToastService;

  @resolve(IdentityService)
  public identity: IdentityService;

  public render() {
    return (
    <React.Fragment>
      <Modal
          visible={this.state.forgotPassword}
          type='dark'
          size='complete'
          closable
          onCancel={() => this.setState({forgotPassword: false})}
        >
          
        <Grid centered><Col size={60}>
          <Form onSubmit={this.forgotPassword} disabled={this.state.loadingPassword}>
                  <div className='login-form'>
                      <h1>Forgot password?</h1>
                      <FormInput
                        style='light'
                        label='E - mail'
                        extraValidation={e => ({ valid: e != '' && !!e, defaultMessage: 'You must provide a valid email address' })}
                        value={this.state.recoverEmail}
                        errors={this.state.forgotErrors}
                        onChange={e => this.setState({recoverEmail: e})}
                        placeholder='Enter your email address'
                        extraContent={[
                          <Button disabled={this.state.loadingPassword} key='forgot1' as={<button/>} extraProps={{type: 'submit'}} presentation='dark' className='login-btn' >
                            {this.state.loadingPassword ? <img src={images.loadingWhite} className="loading-icon fa-spin big-spinner" /> : "Recover"}
                          </Button>
                    
                        ]}
                      />
                      
                      </div>
                  </Form>
                </Col>
              </Grid>
        </Modal>
    <Grid centered><Col size={60}>
        
        <Form onSubmit={this.login} disabled={this.state.loadingLogIn}>
          <div className='login-form'>
          <p className='general-errors'>{this.state.generalErrors && this.state.generalErrors.map((item, index) => item)}</p>
              <FormInput
                style='light'
                label='E - mail'
                extraValidation={e => ({ valid: e != '' && !!e, defaultMessage: 'You must provide a valid email address' })}
                value={this.state.loginEmail}
                errors={this.state.loginErrors}
                onChange={e => this.setState({loginEmail: e})}
                placeholder='Enter your email address'
              />
              <FormInput
                value={this.state.loginPassword}
                onChange={e => this.setState({loginPassword: e})}
                type='password'
                errors={this.state.passwordErrors}
                style='light'
                label='Password'
                extraContent={[
                  <h5 style={{textAlign:'right', margin:0, padding:0}}><a className='forgot' key='forgot' onClick={() => this.setState({forgotPassword: true})}>Forgot password?</a></h5>,
                  <Button disabled={this.state.loadingLogIn} key='forgot1' as={<button/>} extraProps={{type: 'submit'}} presentation='dark' onClick={() => this.props.toggleLogin(true, 0)} className='login-btn' >
                    {this.state.loadingLogIn ? <img src={images.loadingWhite} className="loading-icon fa-spin big-spinner" /> : "Log In"}
                  </Button>
                ,<p  key='forgot2' className='sign-up-link no-absolute not-mobile'>Don't you have an account? <a onClick={() => this.props.toggleLogin(true, 1)}>Sign up</a></p>
            
                ]}
            />

              
              </div>
          </Form>
        </Col>
      </Grid>
    </React.Fragment>);
  }
}



// WEBPACK FOOTER //
// ./src/components/login/parts/login.form.tsx